import React from "react";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import CloseIcon from "material-ui-icons/Close";
import Slide from "material-ui/transitions/Slide";

import {
  buildCycleTableColumns,
  buildOutOfRangesTableColumns,
  buildEventsTableColumns
} from "./builders";
import Input, { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import MediaCard from "./../../components/MediaCard/MediaCard";
import SummaryCard from "./../../components/SummaryCard/SummaryCard";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import UnitsTable from "./../../components/UnitsTable/UnitsTable";
import DatetimePicker from "./../../components/DatetimePicker/DatetimePicker";
import GrowTransition from "./../../components/GrowTransition/GrowTransition";
import AlertMessage from "../../components/AlertMessage/AlertMessage";
import DownloadAs from "../../components/DownloadAs/DownloadAs";
import { TempTimeseries } from "./../../charts";
import "react-table/react-table.css";
import "./Temp.css";
import FetchButton from "../../components/FetchButton/FetchButton";
import FilterTable from "../../components/FilterTable/FilterTable";

import formatNumber from "./../../utilities/numberFormatter";
import Sequence from "./../../utilities/sequence";
import SummaryTripsImage from "./../../images/driving/summary-trips.png";
import SummarySpeedImage from "./../../images/driving/summary-speed.png";
import StartImage from "./../../images/start-marker.png";
import EndImage from "./../../images/end-marker.png";

import TemperaturaMinimaImage from "./../../images/temp/TemperaturaMinima.svg";
import TiempoFueraRangoImage from "./../../images/temp/TiempoFueraRango.svg";
import TiempoRefrigeracionImage from "./../../images/temp/TiempoRefrigeracion.svg";
import TemperaturaMaximaImage from "../../images/temp/TemperaturaMaxima.svg";
import SensoresImage from "../../images/temp/Sensores.svg";
import TermosEncendidosImage from "../../images/temp/TermoEncendido.svg";
import PuertaPrincipalImage from "../../images/temp/PuertaPrincipal.svg";
import PuertaLateralImage from "../../images/temp/PuertaLateral.svg";
import TagSelector from "../../components/TagSelector/TagSelector";

const TempView = props => {
  const {
    lang,
    units,
    isLoading,
    permissions,
    loadedPermissions,
    hasData,
    reportData,
    mostRecentRanges,
    temperatureUnit,
    handleGetData,
    events,
    refrigerationCycles,
    outOfRanges,
    unitRanges,
    isOpenRangeConfiguration,
    handleOpenRangeConfiguration,
    handleCloseRangeConfigutation,
    changeRangeConfiguration,
    undoChangesConfiguration,
    handleInputsConfiguration,
    handleSelectUnitsRanges,
    onBlurInputConfiguration,
    selectedUnitsRange,
    isAllUnitsRangeSelected,
    ranges,
    isAlertMessageOpen,
    alertMessage,
    handleCloseAlertMessage,
    downloadExcel,
    downloadPDF
  } = props;

  let data;
  let fechaPrimerUbicacion;
  let fechaUltimaUbicacion;
  let cyclesTableColumns;
  let eventsColumns;
  let outOfRangesTableColumns;
  if (hasData) {
    data = reportData.Resultados[0];
    eventsColumns = buildEventsTableColumns(lang);
    cyclesTableColumns = buildCycleTableColumns(lang, temperatureUnit);
    outOfRangesTableColumns = buildOutOfRangesTableColumns(
      lang,
      temperatureUnit
    );
    fechaPrimerUbicacion = data.FechaPrimerUbicacion
      ? data.FechaPrimerUbicacion.split("T")
      : "";
    fechaUltimaUbicacion = data.FechaUltimaUbicacion
      ? data.FechaUltimaUbicacion.split("T")
      : "";
  }

  const sequence = new Sequence(0, 50);
  const duration = 50;

  return (
    <div className="temp">
      {isLoading && <LinearLoader />}

      <div className="root">
        <Grid container spacing={24}>
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            item
            className="grid-item"
          >
            <DownloadAs
              disabled={!(hasData && !isLoading)}
              xls={true}
              pdf={false}
              xlsClick={downloadExcel}
              pdfClick={downloadPDF}
            />

            <Button
              className="set-values-button"
              color="primary"
              variant="raised"
              onClick={handleOpenRangeConfiguration}
            >
              {lang.CambiarRangos}
            </Button>
            <TagSelector />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <UnitsTable
              singleSelect
              extraColumns={[
                {
                  Header: `${lang.LimiteInferior} °${temperatureUnit}`,
                  accessor: "LimiteInferior"
                },
                {
                  Header: `${lang.LimiteSuperior} °${temperatureUnit}`,
                  accessor: "LimiteSuperior"
                }
              ]}
              units={units}
            />
          </Grid>
        </Grid>
      </div>

      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <Paper className="margin-top-bottom rounded" elevation={4}>
              <Grid container>
                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                  <DatetimePicker />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <div className="fetch-button-container">
                    <FetchButton
                      disabled={isLoading}
                      onClick={handleGetData}
                      text={lang.Consultar}
                    />
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>

      {hasData && (
        <div className="root">
          <Grid container spacing={24}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <GrowTransition
                in={!isLoading}
                delay={sequence.next()}
                duration={duration}
              >
                <Paper className="summary rounded" elevation={4}>
                  <Grid container spacing={8}>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Inicio}
                        value={fechaPrimerUbicacion[0]}
                        units={fechaPrimerUbicacion[1]}
                        imageUrl={StartImage}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Fin}
                        value={fechaUltimaUbicacion[0]}
                        units={fechaUltimaUbicacion[1]}
                        imageUrl={EndImage}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.VelocidadMaxima}
                        value={
                          data.VelocidadMaxima
                            ? formatNumber(data.VelocidadMaxima)
                            : ""
                        }
                        units="km/h"
                        imageUrl={SummarySpeedImage}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.DistanciaRecorrida}
                        value={
                          data.DistanciaRecorrida
                            ? formatNumber(data.DistanciaRecorrida)
                            : ""
                        }
                        units="km"
                        imageUrl={SummaryTripsImage}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </GrowTransition>
            </Grid>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.TiempoEnRefrigeracion}
                  imageUrl={TiempoRefrigeracionImage}
                  imageTitle={lang.TiempoEnRefrigeracion}
                  value={data.TiempoRefrigeracion}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.TiempoFueraRango}
                  imageUrl={TiempoFueraRangoImage}
                  imageTitle={lang.TiempoFueraRango}
                  value={data.TiempoFueraRango}
                  className="media-blue"
                  // units="hrs"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.TemperaturaMinima}
                  imageUrl={TemperaturaMinimaImage}
                  imageTitle={lang.TemperaturaMinima}
                  value={data.TemperaturaMinima}
                  units={`°${temperatureUnit}`}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.TemperaturaMaxima}
                  imageUrl={TemperaturaMaximaImage}
                  imageTitle={lang.TemperaturaMaxima}
                  value={data.TemperaturaMaxima}
                  units={`°${temperatureUnit}`}
                  className="media-orange"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.Sensores}
                  imageUrl={SensoresImage}
                  imageTitle={lang.Sensores}
                  value={data.CantidadSensores}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.TermosEncendidos}
                  imageUrl={TermosEncendidosImage}
                  imageTitle={lang.TermosEncendidos}
                  value={data.TermosEncendidos}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.AperturaPuertaPrincipal}
                  imageUrl={PuertaPrincipalImage}
                  imageTitle={lang.AperturaPuertaPrincipal}
                  value={data.AperturasPuertaPrincipal}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                className="grid-item"
              >
                <MediaCard
                  title={lang.AperturaPuertaLateral}
                  imageUrl={PuertaLateralImage}
                  imageTitle={lang.AperturaPuertaLateral}
                  value={data.AperturasPuertaLateral}
                  className="media-blue"
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Paper
                  className="rounded"
                  style={{ height: "350px" }}
                  elevation={4}
                >
                  <TempTimeseries
                    data={data.Ubicaciones}
                    ranges={unitRanges ? unitRanges : []}
                    lang={lang}
                  />
                </Paper>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container spacing={24}>
                <FilterTable
                  lang={lang}
                  data={refrigerationCycles}
                  columns={cyclesTableColumns}
                  showPagination={true}
                  defaultPageSize={5}
                  tableHeader={lang.CiclosRefrigeracion}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={outOfRanges}
                  columns={outOfRangesTableColumns}
                  defaultPageSize={5}
                  showPagination={true}
                  tableHeader={lang.IntervalosFueraRango}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={events}
                  columns={eventsColumns}
                  defaultPageSize={5}
                  showPagination={true}
                  tableHeader={lang.Eventos}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>
          </Grid>
        </div>
      )}

      <Dialog
        fullScreen
        open={isOpenRangeConfiguration}
        onClose={handleCloseRangeConfigutation}
        transition={Transition}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <AppBar>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={handleCloseRangeConfigutation}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className="flex">
                {lang.ConfigurarRangosTemperatura}
              </Typography>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent>
          <div className="range-configuration-container">
            <UnitsTable
              units={units}
              changeSelectedUnits={handleSelectUnitsRanges}
              selectedUnits={selectedUnitsRange}
              isAllSelected={isAllUnitsRangeSelected}
              extraColumns={[
                {
                  Header: `${lang.LimiteInferior} °${temperatureUnit}`,
                  accessor: "LimiteInferior"
                },
                {
                  Header: `${lang.LimiteSuperior} °${temperatureUnit}`,
                  accessor: "LimiteSuperior"
                }
              ]}
            />
            <div className="ranges-inputs">
              <FormControl className="form-control">
                <InputLabel htmlFor="minRange">
                  {lang.LimiteInferior}
                </InputLabel>
                <Input
                  id="minRange"
                  type="number"
                  value={ranges.minRange}
                  onBlur={onBlurInputConfiguration}
                  onChange={handleInputsConfiguration}
                />
              </FormControl>
              <FormControl className="form-control">
                <InputLabel htmlFor="maxRange">
                  {lang.LimiteSuperior}
                </InputLabel>
                <Input
                  id="maxRange"
                  type="number"
                  value={ranges.maxRange}
                  onBlur={onBlurInputConfiguration}
                  onChange={handleInputsConfiguration}
                />
              </FormControl>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={changeRangeConfiguration}
            color="primary"
            variant="raised"
            size="small"
          >
            {lang.AplicarLimites}
          </Button>
          <Button
            onClick={undoChangesConfiguration}
            color="primary"
            variant="raised"
            size="small"
          >
            {lang.RestablecerRangos}
          </Button>
          <Button
            onClick={handleCloseRangeConfigutation}
            color="primary"
            variant="raised"
            size="small"
          >
            {lang.Cancelar}
          </Button>
        </DialogActions>
      </Dialog>
      <AlertMessage
        open={isAlertMessageOpen}
        message={alertMessage}
        handleClose={handleCloseAlertMessage}
      />
    </div>
  );
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export default TempView;



// WEBPACK FOOTER //
// ./src/containers/Temp/TempView.js